// src/views/Information.jsx
import React from "react";
import {
  Box, Container, Typography, CardContent, Table, TableCell, TableHead, TableRow, TableBody, Card
} from "@mui/material";
import InfoNavbar from "../components/Navbars/InfoNavbar";
import PageFade from "../components/Loaders/PageFade";
import ColorizedText from "../components/typography/ColorizedText";
import SectionSubtitle from "../components/typography/SectionSubtitle";
import Footnote from "../components/typography/Footnote";
import SubSubtitle from "../components/typography/SectionSubSubtitle";




const PUB = process.env.PUBLIC_URL || "";
const base = `${PUB}/assets/tokai-images/eye-care/${encodeURIComponent("Lutina-Photo-V2")}`;
const u = (name) => `${base}/${encodeURIComponent(name)}`;
const ui = (stem, ext = "png") => u(`ltnpV2 ${stem}-en.${ext}`);

const blueSectionSx = {
  backgroundColor: "#e9f3fb",
  color: "#444444",
  borderRadius: "10px",
  px: { xs: 2.5, md: 4 },
  py: { xs: 3, md: 4 },

  "& .MuiTypography-root": {
    color: "#444444",
  },

  "& .MuiTypography-caption": {
    color: "rgba(68,68,68,0.75)",
  },
};

const darkSectionSx = {
  backgroundColor: "#150301",
  color: "#fff",
  borderRadius: "10px",
  px: { xs: 2.5, md: 4 },
  py: { xs: 3, md: 4 },

  "& .MuiTypography-root": {
    color: "#fff",
  },

  "& .MuiTypography-caption": {
    color: "rgba(255,255,255,0.75)",
  },
};

const lightCellSx = {
  backgroundColor: "#f5f5f5",
  textAlign: "center",
  verticalAlign: "middle",
};

const DoubleCircle = () => (
  <Box
    sx={{
      width: 20,
      height: 20,
      position: "relative",
      display: "block",
    }}
  >
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        border: "1.5px solid currentColor",
        borderRadius: "50%",
      }}
    />
    <Box
      sx={{
        position: "absolute",
        inset: "4px",
        border: "1.5px solid currentColor",
        borderRadius: "50%",
      }}
    />
  </Box>
);


const rows = [
  ["comparison.thinness", "◯", "◎"],
  ["comparison.distortion", "◎", "◯"],
  ["comparison.blurring", "◎", "△"],
  ["comparison.face", "△", "◎"],
];

const renderSymbol = (value) => {
  if (value === "◎") {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <DoubleCircle />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        fontSize: "20px",
        lineHeight: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {value}
    </Box>
  );
};

export default function Information() {
  return (
    <Box id="top" className="catalog-page" sx={{ pb: 6 }}>
      <PageFade cutoff={900} />
      <InfoNavbar />

      <Box sx={{ height: 92 }} />

      <Container
        maxWidth="lg"
        disableGutters
        sx={{ px: { xs: 0, sm: 2.5, md: 3 }, mt: 4 }}
      >

        <Box id="idx176" className="catalog-hero" sx={{ borderRadius: "10px", mb: 3, scrollMarginTop: 110 }}>

          <ColorizedText text="1.76 Index" />
          <SectionSubtitle sx={{ ml: 2 }}>
            World's thinniest lens material 1.76 index
          </SectionSubtitle>

          <Typography
            sx={{
              mb: 2,
              fontSize: "1.05rem",
              lineHeight: 1.6,
              ml: 2
            }}
          >
            The world’s highest refractive index plastic lens 1.76 material, created by the advanced material development technology of TOKAI OPTICAL, a specialized manufacturer of eyeglass lenses, has been used and loved by many people around the world for a long time. The 1.76 material, which boasts the world’s highest refractive index among plastic lenses, has been highly evaluated in markets around the world for its “amazing thinness” and “outstanding comfort” since the introduction of the double-surface aspheric design, and continues to lead the spectacle lens scene.
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: 4,
              alignItems: "flex-start",
              mb: 4,
              mt: 2,
              mr: 4
            }}
          >

            <Box
              sx={{
                flex: { xs: "1 1 100%", md: "0 0 50%" },
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src="/assets/tokai-images/coatings/176-thickness.jpg"
                alt="Molecular bonds"
                sx={{
                  width: "100%",
                  height: "auto",
                  borderRadius: "10px",
                  display: "block",
                }}
              />
            </Box>

            <Box
              sx={{
                flex: { xs: "1 1 100%", md: "0 0 50%" },
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src="/assets/tokai-images/coatings/176_lens.jpg"
                alt="Hybridization particles"
                sx={{
                  width: "100%",
                  height: "auto",
                  borderRadius: "10px",
                  display: "block",
                }}
              />

            </Box>

          </Box>
        </Box>

        <Box
          id="progressive"
          className="catalog-hero"
          sx={{ mb: 3, scrollMarginTop: 110 }}
        >
          <ColorizedText text="Progressive" />
          <SectionSubtitle sx={{ ml: 2 }}>
            Neuro Select
          </SectionSubtitle>

          {/* FULL BLEED WRAPPER (mobile only) */}
          <Box
            sx={{
              mx: { xs: -3, md: 0 }, // cancels catalog-hero 24px padding on mobile
            }}
          >
            <Box
              sx={{
                mb: 3,
                border: "none",
                boxShadow: "none",
                overflow: "hidden",
              }}
            >
              <CardContent
                sx={{
                  p: { xs: 0, md: 2 }, // remove CardContent padding on mobile
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "stretch", // important (no centering)
                  }}
                >
                  <Box
                    component="img"
                    src="/assets/tokai-images/neuro-science/Neuro-Select/neuro-select-en.png"
                    alt="Neuro Select lifestyle selection"
                    sx={{
                      width: "100%",
                      maxWidth: { xs: "100%", md: 1100 },
                      height: "auto",
                      display: "block",
                      borderRadius: { xs: 0, md: "10px 10px 0 0" },
                    }}
                  />

                  <Box
                    component="img"
                    src="/assets/tokai-images/neuro-science/Neuro-Select/Neuro-Select-selection-en.png"
                    alt="Neuro Select lifestyle selection"
                    sx={{
                      width: "100%",
                      maxWidth: { xs: "100%", md: 1100 },
                      height: "auto",
                      display: "block",
                    }}
                  />

                  <Box
                    component="img"
                    src="/assets/tokai-images/neuro-science/Neuro-Select/Neuro-Select-selection2-en.png"
                    alt="Neuro Select grade selection"
                    sx={{
                      width: "100%",
                      maxWidth: { xs: "100%", md: 1100 },
                      height: "auto",
                      display: "block",
                      borderRadius: { xs: 0, md: "0 0 10px 10px" },
                      mb: { xs: 0, md: 4 },
                    }}
                  />

                  {["9X", "3X", "3"].map((grade) => (
                    <Box
                      key={grade}
                      component="img"
                      src={`/assets/tokai-images/neuro-science/Neuro-Select/Neuro-Select-${grade}-en.png`}
                      alt={`Neuro Select ${grade}`}
                      sx={{
                        width: "100%",
                        maxWidth: { xs: "100%", md: 1100 },
                        height: "auto",
                        display: "block",
                      }}
                    />
                  ))}

                  <Box
                    component="img"
                    src="/assets/tokai-images/neuro-science/Neuro-Select/Neuro-Select-My-Feel-Select-en.png"
                    alt="Neuro Select grade selection"
                    sx={{
                      width: "100%",
                      maxWidth: { xs: "100%", md: 1100 },
                      height: "auto",
                      display: "block",
                      borderRadius: { xs: 0, md: "10px" },
                      mb: { xs: 0, md: 4 },
                      mt: { xs: 0, md: 3 },
                    }}
                  />
                </Box>
              </CardContent>
            </Box>
          </Box>


          <SectionSubtitle sx={{ ml: 2 }}>
            ClairArte
          </SectionSubtitle>

          <Box
            sx={{
              mx: { xs: -3, md: 0 }, // cancels catalog-hero 24px padding on mobile
            }}
          >
            <Box
              sx={{
                mb: 3,
                border: "none",
                boxShadow: "none",
                overflow: "hidden",
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    component="img"
                    src="/assets/tokai-images/progressive/ClairArte/ClairArte-Advanced-triple-control-en.webp"
                    alt="ClairArte"
                    sx={{
                      width: "100%",
                      maxWidth: 1100,
                      height: "auto",
                      display: "block",
                      borderRadius: "10px 10px 0 0",
                    }}
                  />

                  <Box
                    component="img"
                    src="/assets/tokai-images/progressive/ClairArte/ClairArte-balanced-design-en.webp"
                    alt="ClairArte balanced design"
                    sx={{
                      width: "100%",
                      maxWidth: 1100,
                      height: "auto",
                      display: "block",
                    }}
                  />

                  <Box
                    component="img"
                    src="/assets/tokai-images/progressive/ClairArte/ClairArte-Corridor-lengths-en.webp"
                    alt="ClairArte corridor lengths"
                    sx={{
                      width: "100%",
                      maxWidth: 1100,
                      height: "auto",
                      display: "block",
                      borderRadius: "0 0 10px 10px",
                      mb: 4,
                    }}
                  />
                </Box>
              </CardContent>
            </Box>
          </Box>

        </Box>


        <Box id="single-vision" className="catalog-hero" sx={{ borderRadius: "10px", mb: 3, scrollMarginTop: 110 }}>

          <ColorizedText text="Single Vision" />
          <Box sx={{ mx: { xs: -3, md: 0 } }}>
            <Box
              sx={{
                border: "none",
                boxShadow: "none",
                overflow: "hidden",
              }}
            >

              <CardContent sx={{ p: 0 }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    component="img"
                    src="/assets/tokai-images/single-vision/HR-W/hr-w-material.png"
                    alt="Single Vision Table"
                    sx={{
                      width: "100%",
                      maxWidth: 1100,
                      height: "auto",
                      display: "block",
                      borderRadius: "0 0 10px 10px",
                      mb: 4,
                    }}
                  />
                </Box>
              </CardContent>

              <Box sx={{ borderRadius: "10px", overflow: "hidden" }}>

                <SectionSubtitle sx={{ ml: 2 }}>
                  HR-W
                </SectionSubtitle>

                <Box sx={{ ...darkSectionSx }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", md: "row" },
                      alignItems: "center",
                      gap: { xs: 3, md: 6 },
                      textAlign: { xs: "center", md: "left" },
                    }}
                  >
                    <Box
                      sx={{
                        flex: { md: "0 0 35%" },
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        component="img"
                        src="/assets/tokai-images/single-vision/HR-W/hr-w-nb-logo.png"
                        alt="HR-W Logo"
                        sx={{
                          maxWidth: "100%",
                          height: "auto",
                        }}
                      />
                    </Box>

                    <Box
                      sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                    >
                      <SectionSubtitle sx={{ mb: 1 }}>
                        HR-W Double Aspheric Design
                      </SectionSubtitle>

                      <Typography
                        sx={{
                          mb: 2,
                          fontSize: "1.05rem",
                          lineHeight: 1.6,
                          maxWidth: 520,
                        }}
                      >
                        “Hi-ResTech,” which is the technology for clear vision design, has been upgraded to a double-sided aspheric lens. It has evolved into a high-performance lens through which you can enjoy a clearer, more natural, and more comfortable field of vision.
                      </Typography>

                      <Box sx={{ mt: 1 }}>
                        <Box
                          component="img"
                          src="/assets/tokai-images/single-vision/HR-W/hr-w-nb-Hi-ResTech-en.png"
                          alt="Hi-ResTech Technology"
                          sx={{
                            maxWidth: "70%",
                            width: "100%",
                            height: "auto",
                          }}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Box>

                <Box
                  sx={{
                    px: { xs: 2.5, md: 4 },
                    py: { xs: 3, md: 4 },
                    backgroundColor: "#fff",
                  }}
                >

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", md: "row" },
                      gap: { xs: 4, md: 8 },
                      textAlign: { xs: "center", md: "left" },
                    }}
                  >
                    {/* LEFT */}
                    <Box sx={{ flex: 1 }}>
                      <SectionSubtitle>Design for each HR-W type</SectionSubtitle>
                      <Typography sx={{ fontSize: "1rem", lineHeight: 1.6 }}>
                        Sophisticated original design. HR-W comes in two types and meets customer needs.
                      </Typography>
                    </Box>

                    {/* RIGHT */}
                    <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
                      <Box sx={{ width: "75%" }}>
                        <Box
                          component="img"
                          src="/assets/tokai-images/single-vision/HR-W/hr-w-c-s-extra-en.png"
                          alt="Cleary and Shapely"
                          sx={{ width: "100%", height: "auto", display: "block" }}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Box>


                <Box
                  sx={{
                    backgroundColor: "#fdf7e6",
                    px: { xs: 2.5, md: 4 },
                    py: { xs: 3, md: 3.5 },
                    borderRadius: "10px 10px 0px 0px"
                  }}
                >
                  <SectionSubtitle>Focusing on vision (Clearly)</SectionSubtitle>
                  <Typography sx={{ fontSize: "1rem", lineHeight: 1.6 }}>
                    Higher clearness than Bi-AS (C). Clear and natural field of vision.
                  </Typography>
                </Box>

                <Box
                  sx={{
                    backgroundColor: "#fdf7e6",
                    p: 2
                  }}
                >
                  <Box
                    component="img"
                    src="/assets/tokai-images/single-vision/HR-W/hr-w-focus-on-vision-en.png"
                    alt="Focus on Shape"
                    sx={{ width: "100%", height: "auto", display: "block" }}
                  />
                </Box>

                <Box
                  sx={{
                    backgroundColor: "#e7f2fb",
                    px: { xs: 2.5, md: 4 },
                    py: { xs: 3, md: 3.5 }
                  }}
                >
                  <SectionSubtitle>Focusing on thinness (Shapely)</SectionSubtitle>
                  <Typography sx={{ fontSize: "1rem", lineHeight: 1.6 }}>
                    Highest index in the world*1 Incredible thinness realized by combination with 1.76.
                  </Typography>
                  <Footnote>
                    *1 Comparison between lenses of plastic materials. Surveyed by Tokai Optical in August 2023.
                  </Footnote>
                </Box>

                <Box
                  sx={{
                    backgroundColor: "#e7f2fb",
                    p: 2,
                    borderRadius: "0px 0px 10px 10px",
                    mb: 3
                  }}
                >
                  <Box
                    component="img"
                    src="/assets/tokai-images/single-vision/HR-W/hr-w-focus-on-shape-en.png"
                    alt="Focus on Shape"
                    sx={{ width: "100%", height: "auto", display: "block" }}
                  />
                </Box>

                <Box>
                  <SectionSubtitle>Compare HR-W Designs</SectionSubtitle>

                  <Box sx={{ borderRadius: "10px", overflow: "hidden" }}>
                    <Table
                      size="small"
                      sx={{
                        width: "100%",
                        tableLayout: "fixed",
                        borderCollapse: "separate",
                        borderSpacing: 0,

                        "& th, & td": {
                          py: 1.5,
                          borderRight: "1px solid #fff",
                        },

                        "& tbody td": {
                          borderTop: "1px solid #fff",
                        },

                        "& th:last-of-type, & td:last-of-type": {
                          borderRight: "none",
                        },
                      }}
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell
                            sx={{
                              backgroundColor: "#dfe4ea",
                              fontWeight: 700,
                              textAlign: "center",
                              width: "55%",
                            }}
                          >
                            Performance
                          </TableCell>

                          <TableCell
                            sx={{
                              backgroundColor: "#c9a227",
                              fontWeight: 700,
                              textAlign: "center",
                              width: "22.5%",
                            }}
                          >
                            Clearly
                          </TableCell>

                          <TableCell
                            sx={{
                              backgroundColor: "#5b8296",
                              fontWeight: 700,
                              color: "#fff",
                              textAlign: "center",
                              width: "22.5%",
                            }}
                          >
                            Shapely
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {rows.map(([labelKey, clearly, shapely], i) => {
                          const zebra = i % 2 === 0 ? "#f4f6f8" : "#eef2f5";

                          const labels = {
                            "comparison.thinness": "Thinness of lens",
                            "comparison.distortion": "Distortion correction",
                            "comparison.blurring": "Blurring correction",
                            "comparison.face": "Face line distortion correction",
                          };

                          return (
                            <TableRow key={i}>
                              <TableCell
                                sx={{
                                  backgroundColor: zebra,
                                  textAlign: "center",
                                  fontWeight: 500,
                                  px: 2,
                                }}
                              >
                                {labels[labelKey]}
                              </TableCell>

                              <TableCell sx={{ ...lightCellSx, backgroundColor: zebra }}>
                                {renderSymbol(clearly)}
                              </TableCell>

                              <TableCell sx={{ ...lightCellSx, backgroundColor: zebra }}>
                                {renderSymbol(shapely)}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </Box>

                  <Box
                    sx={{
                      mt: 1,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                      gap: 0.5,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 3,
                        color: "text.secondary",
                        fontSize: "0.75rem",
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                        <DoubleCircle />
                        <Box component="span">Very good</Box>
                      </Box>

                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                        <Box component="span" sx={{ fontSize: 18, lineHeight: 1 }}>
                          ◯
                        </Box>
                        <Box component="span">Good</Box>
                      </Box>

                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                        <Box component="span" sx={{ fontSize: 18, lineHeight: 1 }}>
                          △
                        </Box>
                        <Box component="span">OK</Box>
                      </Box>
                    </Box>

                  </Box>
                </Box>

              </Box>
            </Box>
          </Box>

        </Box>


        <Box id="photochromic" className="catalog-hero" sx={{ borderRadius: "10px", mb: 3, scrollMarginTop: 110 }}>
          <ColorizedText text="Photochromic" />
          <SectionSubtitle sx={{ ml: 2 }}>
            Lutina Photo V2
          </SectionSubtitle>
          <Box
            sx={{
              border: "none",
              boxShadow: "none",
              overflow: "hidden",
            }}
          >
            <CardContent sx={{ p: 0 }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box
                  component="img"
                  src="/assets/tokai-images/eye-care/Lutina-Photo-V2/ltnpV2-logo-en.png"
                  alt="Single Vision Table"
                  sx={{
                    width: "100%",
                    maxWidth: 1100,
                    height: "auto",
                    display: "block",
                    borderRadius: "10px 10px 10px 10px",
                  }}
                />
              </Box>
            </CardContent>

          </Box>

          <Box>
            <SectionSubtitle sx={{ ml: 2 }}>Our popular LUTINA PHOTO has been renewed with higher performance</SectionSubtitle>

            <Typography sx={{ ml: 2 }} paragraph>
              LUTINA PHOTO V2 has overcome the weak points of conventional photochromic lenses; its color changes deep with sunlight at high temperatures.※
            </Typography>

            <Typography sx={{ mr: 2, mt: -2, textAlign: "right" }} variant="body2" color="text.secondary">
              ※High temperatures refer to approximately 40°C.
            </Typography>

            <Card sx={{ mb: 3, boxShadow: "none" }}>
              <CardContent sx={{ p: 0 }}>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mb: 3,
                    backgroundColor: "#a9bbc4",
                    borderRadius: "10px"
                  }}
                >
                  <Box
                    component="img"
                    src={u("ltnpV2-en.png")}
                    alt="Lutina Photo V2 Features"
                    sx={{ maxWidth: 720, width: "100%", height: "auto", p: 3 }}
                  />
                </Box>

                <Box>
                  <SectionSubtitle>Advanced Photochromic Protection</SectionSubtitle>
                  <Typography sx={{ fontSize: "1rem", lineHeight: 1.6, mb: 1 }}>
                    A photochromic lens automatically adjusts its tint in response to sunlight to reduce glare and improve visual comfort.
                  </Typography>
                  <Typography sx={{ fontSize: "1rem", lineHeight: 1.6 }}>
                    The lens darkens as ultraviolet (UV) exposure increases and becomes lighter indoors.
                  </Typography>
                  <Typography sx={{ fontSize: "1rem", lineHeight: 1.6 }}>
                    Lower temperatures intensify the color depth, while higher temperatures reduce activation strength.
                  </Typography>
                  <Footnote>
                    High temperatures refer to approximately 40°C.
                  </Footnote>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mb: 3,
                  }}
                >
                  <Box
                    component="img"
                    src={u("ltnpV2 GY-BR-2-en.png")}
                    alt="Lutina Photo V2 Features"
                    sx={{ maxWidth: 720, width: "100%", height: "auto", p: 3 }}
                  />
                </Box>

                <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: 1, mb: 2, px: { xs: 2, sm: 3, md: 4 } }}>
                  <Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
                      <Box component="img" src={ui("P1")} alt="Point 01" sx={{ height: 100, width: "auto", maxWidth: 350 }} />
                    </Box>

                    <Typography sx={{ mt: 1.25, maxWidth: 400, fontSize: "1.2rem" }}>
                      <Box component="strong" sx={{ display: "inline-block", mb: 1 }}>
                        The density of lens color becomes darker even at high temperatures.
                      </Box>
                      <br />
                      LUTINA PHOTO V2 is a high-level photochromic lens that deepens color density even in heat, overcoming a shortcoming of conventional photochromic lenses.
                    </Typography>

                  </Box>

                  <Box>
                    <Box sx={{ backgroundColor: "#e2a934", color: "#fff", fontWeight: 700, fontSize: { xs: "0.95rem", md: "1.2rem" }, px: 2, py: 1, borderRadius: 1, mb: 3, textAlign: "center", mt: 1.25 }}>
                      Deep color payoff even at high temperatures
                    </Box>

                    <Box component="img" src={ui("P1-1")} alt="Comparison" sx={{ width: "100%", height: "auto", borderRadius: 1, display: "block" }} />
                  </Box>
                </Box>

                <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: 1, mb: 2, px: { xs: 2, sm: 3, md: 4 } }}>
                  <Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
                      <Box component="img" src={u("ltnpV2 P2.png")} alt="Point 02" sx={{ height: 100, width: "auto", maxWidth: 350 }} />
                    </Box>

                    <Typography sx={{ mt: 1.25, maxWidth: 400, fontSize: "1.2rem" }}>
                      <Box component="strong" sx={{ display: "inline-block", mb: 1 }}>
                        Eye care anytime by adjusting color brightness.
                      </Box>
                      <br />
                      A photochromic lens made of LUTINA material that can be used 24 hours a day—supporting your eyes indoors and outdoors.
                    </Typography>
                  </Box>

                  <Box>
                    <Box sx={{ backgroundColor: "#a9bbc4", color: "#fff", fontWeight: 700, fontSize: { xs: "0.95rem", md: "1.2rem" }, px: 2, py: 1, borderRadius: 1, mb: 3, textAlign: "center", mt: 1.25 }}>
                      Available in every situation
                    </Box>

                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                      <Box component="img" src={ui("P2-1")} alt="Key points" sx={{ width: "100%", height: "auto", borderRadius: 1, display: "block" }} />
                      <Box component="img" src={u("ltnpV2 P2-2.jpg")} alt="Lifestyle" sx={{ width: "100%", height: "auto", borderRadius: 1, display: "block" }} />
                    </Box>
                  </Box>
                </Box>

                <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: 1, mb: 2, px: { xs: 2, sm: 3, md: 4 } }}>
                  <Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
                      <Box component="img" src={u("ltnpV2 P3.png")} alt="Point 03" sx={{ height: 100, width: "auto", maxWidth: 350 }} />
                    </Box>

                    <Typography sx={{ mt: 1.25, maxWidth: 400, fontSize: "1.2rem" }}>
                      <Box component="strong" sx={{ display: "inline-block", mb: 1 }}>
                        Protecting eyes against ultraviolet rays coming from 360° — P-UV as standard.
                      </Box>
                      <br />
                      Blocks UV entering from the front surfaces and significantly reduces UV reflected from the back surfaces of the lenses.
                    </Typography>
                  </Box>

                  <Box>
                    <Box sx={{ backgroundColor: "#a9bbc4", color: "#fff", fontWeight: 700, fontSize: { xs: "0.95rem", md: "1.2rem" }, px: 2, py: 1, borderRadius: 1, mb: 3, textAlign: "center", mt: 1.25 }}>
                      Blocks back-surface UV reflections significantly
                    </Box>

                    <Box component="img" src={ui("P3-1")} alt="UV Blocking" sx={{ width: "100%", height: "auto", borderRadius: 1, display: "block" }} />
                  </Box>
                </Box>

              </CardContent>
            </Card>

          </Box>

          <Box
            sx={{
              border: "none",
              boxShadow: "none",
              overflow: "hidden",
            }}
          >
            <CardContent sx={{ p: 0 }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box
                  component="img"
                  src="/assets/tokai-images/functional-lens/tint-ltnp.webp"
                  alt="Single Vision Table"
                  sx={{
                    width: "100%",
                    maxWidth: 1100,
                    height: "auto",
                    display: "block",
                    borderRadius: "10px 10px 10px 10px",
                  }}
                />
              </Box>
            </CardContent>

            <Box>
              <SectionSubtitle>Available with tints</SectionSubtitle>
              <Typography sx={{ fontSize: "1rem", lineHeight: 1.6 }}>
                Choose between three colors of Lutina Photo V2 to suit your style.
              </Typography>
            </Box>
            <Box>
              <Box
                component="img"
                src="/assets/tokai-images/functional-lens/tint-selection.webp"
                alt="Focus on Shape"
                sx={{ width: "100%", height: "auto", display: "block" }}
              />
            </Box>

          </Box>

        </Box>

        <Box
          id="coatings"
          className="catalog-hero"
          sx={{ borderRadius: "10px", mb: 3, scrollMarginTop: 110 }}
        >
          <ColorizedText text="Coatings" />

          <SectionSubtitle sx={{ ml: 2 }}>
            Ultra Shield Performance (USP)
          </SectionSubtitle>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Box
              component="img"
              src="/assets/tokai-images/coatings/usp-logo.jpg"
              alt="Ultra Shield Performance"
              sx={{
                width: "100%",
                maxWidth: 1100,
                height: "auto",
                display: "block",
                borderRadius: "10px 10px 0 0",
              }}
            />
          </Box>

          <Box sx={{ ...blueSectionSx, borderRadius: "0 0 10px 10px" }}>

            <SectionSubtitle>Durability and Low Reflection Combined</SectionSubtitle>

            <Typography sx={{ mb: 3, fontSize: "1.05rem", lineHeight: 1.6 }}>
              Ultra Shield Performance is designed for daily durability, visual comfort,
              and refined appearance. It provides resistance to scratches, dirt, dust,
              and perspiration while maintaining beautiful, low-reflection aesthetics.
            </Typography>

            <Box sx={{ mb: 4 }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" }, // 👈 key change
                  alignItems: { xs: "flex-start", md: "center" },
                  gap: 2,
                  pb: 1,
                  mb: 2,
                  borderBottom: "2px solid rgba(0,0,0,0.2)",
                }}
              >
                <Box
                  component="img"
                  src="/assets/tokai-images/coatings/usp-strong.svg"
                  alt="Strong"
                  sx={{ height: 36, width: "auto", display: "block", flexShrink: 0 }}
                />

                <Typography
                  sx={{
                    fontSize: { xs: "0.95rem", md: "1.05rem" },
                    fontStyle: "italic",
                    fontWeight: 500,
                  }}
                >
                  2 times* stronger to scratches and durable compared to the MSC.
                </Typography>
              </Box>


              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  gap: 4,
                  alignItems: "flex-start",
                }}
              >
                <Box sx={{ flex: { xs: "1 1 100%", md: "0 0 70%" } }}>
                  <Typography sx={{ fontSize: "1.05rem", lineHeight: 1.6 }}>
                    The greatest strength of Ultra Shield Performance is the high-hardness
                    hard coating made with high molecular density and hybridized molecules
                    and particles. With the high-density multi-coating combined, the coating
                    achieves improved scratch resistance and long-term durability.
                  </Typography>
                </Box>

                <Box
                  sx={{
                    flex: { xs: "1 1 100%", md: "0 0 30%" },
                    pr: { xs: 0, md: 4 },
                    boxSizing: "border-box",
                  }}
                >
                  <Box
                    component="img"
                    src="/assets/tokai-images/coatings/usp-glasses.jpg"
                    alt="Ultra Shield glasses"
                    sx={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "10px",
                      display: "block",
                    }}
                  />
                </Box>

              </Box>
            </Box>


            <SubSubtitle>Improved scratch resistance for peace of mind!</SubSubtitle>

            <Typography sx={{ mb: 2, fontSize: "1.05rem", lineHeight: 1.6 }}>
              Approximately 2 times* more scratch-resistant than Max Shield Coating.
            </Typography>

            <Box
              component="img"
              src="/assets/tokai-images/coatings/usp-comp.png"
              alt="ClairArte"
              sx={{
                width: "100%",
                maxWidth: "80%",
                height: "auto",
                display: "block",
                borderRadius: "10px 10px 0 0",
                mb: 3
              }}
            />

            <Typography sx={{ mb: -1, fontSize: "1.05rem", lineHeight: 1.6 }}>
              Specialized inhouse scratch test 2kg x 150 round trips (#000)
            </Typography>
            <Footnote>
              ※ Magnified 400times under a microscope
            </Footnote>

            <SubSubtitle sx={{ mt: 3 }}>Scratch-resistant and long-lasting even after long-term use!</SubSubtitle>

            <Typography sx={{ mb: 2, fontSize: "1.05rem", lineHeight: 1.6 }}>
              The scratch resistance performance does not degrade even after the ccelerated weathering test.
            </Typography>

            <Box
              component="img"
              src="/assets/tokai-images/coatings/usp-accelerated.png"
              alt="ClairArte"
              sx={{
                width: "100%",
                maxWidth: "70%",
                height: "auto",
                display: "block",
                borderRadius: "10px 10px 0 0",
                mb: 3
              }}
            />

            <Typography sx={{ mb: -1, fontSize: "1.05rem", lineHeight: 1.6 }}>
              Specialized inhouse scratch test 2kg x 150 round trips (#000) after accelerated weathering test.
            </Typography>
            <Footnote>
              ※ Magnified 400times under a microscope
            </Footnote>

            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: { xs: "center", md: "flex-start" },
                gap: { xs: 4, md: 6 },
                mb: 4,
                backgroundColor: "#fff",
                borderRadius: "10px",
                p: 3
              }}
            >

              <Box sx={{ flex: 1, textAlign: { xs: "center", md: "left" } }}>

                <Box sx={{ textAlign: "center", mb: 2 }}>
                  <SectionSubtitle sx={{ mb: -0.5 }}>
                    TOKAI’s proprietary<br />
                    scratch manifestation test
                  </SectionSubtitle>

                  <Footnote>
                    (Japanese Patent No.5740607)
                  </Footnote>
                </Box>


                <Typography sx={{ fontSize: "1.05rem", lineHeight: 1.7 }}>
                  Minute scratches caused by daily care and external factors are enlarged
                  by ultraviolet rays, heat, water, and sweat in daily life and become
                  visible scratches.
                </Typography>

                <Typography sx={{ mt: 2, fontSize: "1.05rem", lineHeight: 1.7 }}>
                  Therefore, we devised an original test method that assumes daily use.
                  As a result, we have developed a scratch-resistant and durable lens
                  coating that can withstand harsh conditions.
                </Typography>

              </Box>


              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Box
                  component="img"
                  src="/assets/tokai-images/coatings/usp-test.png"
                  alt="TOKAI scratch manifestation test"
                  sx={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "10px",
                    display: "block",
                  }}
                />
              </Box>

            </Box>

            <SubSubtitle sx={{ mt: 3, mb: 2 }}>Reasons for the strength of Ultra Shield Performance</SubSubtitle>



            <Box sx={{ display: "flex", gap: 2 }}>

              <Box sx={{ width: 36, flexShrink: 0 }}>
                <Box
                  component="img"
                  src="/assets/tokai-images/coatings/usp-no01.svg"
                  alt="01"
                  sx={{ width: "100%", height: "50px" }}
                />
              </Box>

              <Box sx={{ flex: 1 }}>
                <SectionSubtitle sx={{ mb: 1 }}>
                  Ultra hard hard coating
                </SectionSubtitle>

                <Typography sx={{ fontSize: "1.05rem", lineHeight: 1.6 }}>
                  Unparalleled scratch resistance is realized by increasing hardness
                  through molecular densification and hybridization of molecules and fine particles.
                </Typography>
              </Box>

            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                gap: { xs: 0, md: 4 },
                alignItems: { xs: "stretch", md: "flex-start" },
                mb: { xs: 0, md: 4 },
                mt: { xs: 0, md: 2 },
                mr: { xs: 0, md: 4 },
              }}
            >
              <Box
                sx={{
                  flex: { xs: "1 1 100%", md: "0 0 50%" },
                  display: "flex",
                  flexDirection: "column",
                  alignItems: { xs: "stretch", md: "center" },
                }}
              >
                <Box
                  component="img"
                  src="/assets/tokai-images/coatings/usp-bonds.png"
                  alt="Molecular bonds"
                  sx={{
                    width: "100%",
                    height: "auto",
                    borderRadius: { xs: 0, md: "10px" },
                    display: "block",
                  }}
                />

                <Footnote
                  sx={{
                    mt: { xs: 0, md: 2 },
                    textAlign: "center",
                    maxWidth: { xs: "100%", md: 400 },
                    px: { xs: 2, md: 0 },
                  }}
                >
                  Higher hardness by densifying molecular bonds
                </Footnote>
              </Box>


              <Box
                sx={{
                  flex: { xs: "1 1 100%", md: "0 0 50%" },
                  display: "flex",
                  flexDirection: "column",
                  alignItems: { xs: "stretch", md: "center" },
                }}
              >
                <Box
                  component="img"
                  src="/assets/tokai-images/coatings/usp-particals.png"
                  alt="Hybridization particles"
                  sx={{
                    width: "100%",
                    height: "auto",
                    borderRadius: { xs: 0, md: "10px" },
                    display: "block",
                  }}
                />

                <Footnote
                  sx={{
                    mt: { xs: 0, md: 2 },
                    textAlign: "center",
                    maxWidth: { xs: "100%", md: 420 },
                    px: { xs: 2, md: 0 },
                  }}
                >
                  Hybridization, in which molecules and fine particles are bonded without gaps, results in high hardness.
                </Footnote>
              </Box>

            </Box>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", md: "1.1fr 0.9fr" },
                gap: 4,
                mt: 2,
                mb: 4,
                alignItems: "start",
              }}
            >
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                    alignItems: "flex-start",
                    minHeight: 56,
                  }}
                >
                  <Box sx={{ width: 36, flexShrink: 0, mt: "2px" }}>
                    <Box
                      component="img"
                      src="/assets/tokai-images/coatings/usp-no02.svg"
                      alt="01"
                      sx={{ width: "100%", height: "50px", display: "block" }}
                    />
                  </Box>

                  <Box sx={{ flex: 1 }}>
                    <SectionSubtitle sx={{ mb: 1 }}>
                      High-density multi-coat
                    </SectionSubtitle>

                    <Typography sx={{ fontSize: "1.05rem", lineHeight: 1.6 }}>
                      The higher density multi coating improves hardness, making it scratch-resistant even under harsh conditions.
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ mt: 2, display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <Box
                    component="img"
                    src="/assets/tokai-images/coatings/usp-affection.png"
                    alt="High-density multi-coat illustration"
                    sx={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "10px",
                      display: "block",
                    }}
                  />

                  <Footnote sx={{ mt: 2, textAlign: "center", maxWidth: "100%" }}>
                    High hardness with high density results to less affection from water and perspiration
                  </Footnote>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                    alignItems: "flex-start",
                    mt: 5,
                  }}
                >
                  <Box sx={{ height: 50, width: 36, flexShrink: 0 }}>
                    <Box
                      component="img"
                      src="/assets/tokai-images/coatings/usp-no03.svg"
                      alt="03"
                      sx={{
                        height: "100%",
                        width: "auto",
                        display: "block",
                      }}
                    />
                  </Box>

                  <Box sx={{ flex: 1 }}>
                    <SectionSubtitle sx={{ mb: 1 }}>
                      Special fluorine treatment process
                    </SectionSubtitle>

                    <Typography sx={{ fontSize: "1.05rem", lineHeight: 1.6 }}>
                      The fluorine treatment makes low coefficient of friction and does not apply extra load when wiping lenses, making them scratch resistant.
                    </Typography>
                  </Box>
                </Box>

              </Box>

              <Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                    alignItems: "center",
                    minHeight: 56,
                  }}
                >
                  <Box sx={{ flex: 1, textAlign: "center" }}>
                    <SectionSubtitle sx={{ mb: 1 }}>
                      Coating Structure
                    </SectionSubtitle>
                  </Box>
                </Box>

                <Box sx={{ mt: 2, display: "flex", flexDirection: "column", alignItems: "center", }}>
                  <Box
                    component="img"
                    src="/assets/tokai-images/coatings/usp-structure.png"
                    alt="Coating structure"
                    sx={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "10px",
                      display: "block",
                      maxWidth: "302px"
                    }}
                  />
                </Box>
              </Box>
            </Box>



            <Box sx={{ mb: 4 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  flexWrap: "wrap",
                  pb: 1,
                  mb: 2,
                  borderBottom: "2px solid rgba(0,0,0,0.2)",
                }}
              >
                <Box
                  component="img"
                  src="/assets/tokai-images/coatings/usp-no-reflection.svg"
                  alt="No Reflection"
                  sx={{ height: 36, width: "auto", display: "block" }}
                />

                <Typography
                  sx={{
                    fontSize: { xs: "0.95rem", md: "1.05rem" },
                    fontStyle: "italic",
                    fontWeight: 500,
                    whiteSpace: "nowrap",
                  }}
                >
                  Reduced visual reflectance
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  gap: 4,
                  alignItems: "flex-start",
                }}
              >
                <Box sx={{ flex: { xs: "1 1 100%", md: "0 0 70%" } }}>
                  <Typography sx={{ fontSize: "1.05rem", lineHeight: 1.6 }}>
                    Glasses shine in web conferencing.<br />
                    Because it is through a screen, it is necessary to make a beautiful impression on the other party.
                    Reduced reflectivity compared to conventional lenses.
                    Reflected light is suppressed and the eyes appear clearer.
                  </Typography>
                </Box>

                <Box
                  sx={{
                    flex: { xs: "1 1 100%", md: "0 0 30%" },
                    pr: { xs: 0, md: 4 },
                    boxSizing: "border-box",
                  }}
                >
                  <Box
                    component="img"
                    src="/assets/tokai-images/coatings/usp-refelection.jpg"
                    alt="Ultra Shield glasses"
                    sx={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "10px",
                      display: "block",
                    }}
                  />
                </Box>

              </Box>
            </Box>




            <SubSubtitle sx={{ mt: 3, mb: 2 }}>CLEAN – High Water and Oil Repellency</SubSubtitle>

            <Typography sx={{ mb: 3, fontSize: "1.05rem", lineHeight: 1.6 }}>
              A new standard focusing on visual sensitivity, achieving a visual sensitivity reflectance of approximately 0.25%*.
              The eyes look beautiful when viewed by others or through a monitor.
            </Typography>


            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src="/assets/tokai-images/coatings/usp-change.png"
                alt="ClairArte"
                sx={{
                  width: "100%",
                  maxWidth: { xs: "100%", md: "80%" },
                  height: "auto",
                  borderRadius: "10px 10px 0 0",
                  mb: 2,
                }}
              />

              <Footnote
                sx={{
                  textAlign: "center",
                  maxWidth: { xs: "100%", md: "80%" },
                  mb: 4,
                  pr: 12
                }}
              >
                * Actual measured value of refractive index 160 USP.<br />
                This value is not the value specified by the manufacturer according to JIST 7334.
              </Footnote>
            </Box>


            <Box sx={{ mb: 4 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  flexWrap: "wrap",
                  pb: 1,
                  mb: 2,
                  borderBottom: "2px solid rgba(0,0,0,0.2)",
                }}
              >
                <Box
                  component="img"
                  src="/assets/tokai-images/coatings/usp-clean-title.svg"
                  alt="No Reflection"
                  sx={{ height: 36, width: "auto", display: "block" }}
                />

                <Typography
                  sx={{
                    fontSize: { xs: "0.95rem", md: "1.05rem" },
                    fontStyle: "italic",
                    fontWeight: 500,
                    whiteSpace: "nowrap",
                  }}
                >
                  High water and oil repellency
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  gap: 4,
                  alignItems: "flex-start",
                  mt: 3,
                }}
              >
                <Box sx={{ flex: { xs: "1 1 100%", md: "0 0 40%" } }}>
                  <SubSubtitle sx={{ mb: 2 }}>
                    Stain-resistant and easy to clean!
                  </SubSubtitle>

                  <Typography sx={{ fontSize: "1.05rem", lineHeight: 1.6 }}>
                    High water and oil repellency with excellent stain resistance performance,
                    it is stain resistant and easy to wipe off.
                  </Typography>
                </Box>

                <Box
                  sx={{
                    flex: { xs: "1 1 100%", md: "0 0 60%" },
                    pr: { xs: 0, md: 4 },
                    boxSizing: "border-box",
                  }}
                >
                  <Box
                    component="img"
                    src="/assets/tokai-images/coatings/usp-clean.png"
                    alt="Ultra Shield clean illustration"
                    sx={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "10px",
                      display: "block",
                    }}
                  />
                </Box>
              </Box>
            </Box>


            <Box sx={{ mb: 4 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  flexWrap: "wrap",
                  pb: 1,
                  mb: 2,
                  borderBottom: "2px solid rgba(0,0,0,0.2)",
                }}
              >
                <Box
                  component="img"
                  src="/assets/tokai-images/coatings/usp-clean-title.svg"
                  alt="No Reflection"
                  sx={{ height: 36, width: "auto", display: "block" }}
                />

                <Typography
                  sx={{
                    fontSize: { xs: "0.95rem", md: "1.05rem" },
                    fontStyle: "italic",
                    fontWeight: 500,
                    whiteSpace: "nowrap",
                  }}
                >
                  With anti-static function
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  gap: 4,
                  alignItems: "flex-start",
                  mt: 3,
                }}
              >
                <Box sx={{ flex: { xs: "1 1 100%", md: "0 0 40%" } }}>
                  <SubSubtitle sx={{ mb: 2 }}>
                    Dust-resistant and comfortable!
                  </SubSubtitle>

                  <Typography sx={{ fontSize: "1.05rem", lineHeight: 1.6 }}>
                    The anti-static function prevents dust from sticking to the surface, making it easy to clean.
                  </Typography>
                </Box>

                <Box
                  sx={{
                    flex: { xs: "1 1 100%", md: "0 0 60%" },
                    pr: { xs: 0, md: 4 },
                    boxSizing: "border-box",
                  }}
                >
                  <Box
                    component="img"
                    src="/assets/tokai-images/coatings/usp-dust.png"
                    alt="Ultra Shield clean illustration"
                    sx={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "10px",
                      display: "block",
                    }}
                  />
                </Box>
              </Box>
            </Box>

            <Footnote sx={{ display: "block", mb: 1 }}>
              ※Compared to our company with 1.60 material lens *Even coated lenses with improved scratch resistance and durability may become scratched or the coating may crack due to excessive impact or handling.<br />
            </Footnote>

            <Footnote sx={{ display: "block", mb: 1 }}>
              ※All comparison photos are based on our company’s comparison with lenses made of material with a refractive index of 1.60. *Spectral characteristics may vary depending on the material and coating.<br />
            </Footnote>

            <Footnote sx={{ display: "block" }}>
              ※The actual color differs due to printing conditions. *All photos and illustrations are for illustrative purposes only.
            </Footnote>

          </Box>
        </Box>

      </Container >
    </Box >
  );
}
